module.exports = __webpack_public_path__ + "img/成果展示banner.fb56243d.png";